import type { SidebarData, SidebarLink } from '@/data/types';

interface SidebarProps {
  sidebarData: SidebarData;
}

interface SidebarWidgetProps {
  title: string;
  links: SidebarLink[];
}

function SidebarWidget({ title, links }: SidebarWidgetProps) {
  if (links.length === 0) return null;

  return (
    <li className="mb-6">
      <p className="text-xl font-bold text-gray-700 mb-3 font-serif">
        {title}
      </p>
      <ul className="space-y-1">
        {links.map((link, index) => (
          <li key={index}>
            <a
              href={link.url}
              className="text-sm text-gray-700 hover:text-blue-600 transition-colors duration-200"
            >
              {link.title}
            </a>
          </li>
        ))}
      </ul>
    </li>
  );
}

function SearchWidget() {
  return (
    <li className="mb-6">
      <p className="text-xl font-bold text-gray-700 mb-3 font-serif">
        Search
      </p>
      <div className="flex">
        <input
          type="search"
          placeholder="Search..."
          className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-l focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
        />
        <button
          type="submit"
          className="px-4 py-2 bg-blue-600 text-white text-sm rounded-r hover:bg-blue-700 transition-colors duration-200"
        >
          Search
        </button>
      </div>
    </li>
  );
}

export function Sidebar({ sidebarData }: SidebarProps) {
  return (
    <aside id="sidebar" className="w-full lg:w-80 bg-white">
      <ul id="widgetlist" className="list-none p-0">
        <SearchWidget />
        <SidebarWidget 
          title="Recent Posts" 
          links={sidebarData.recentPosts} 
        />
        <SidebarWidget 
          title="Recent Comments" 
          links={sidebarData.recentComments} 
        />
        <SidebarWidget 
          title="Archives" 
          links={sidebarData.archives} 
        />
        <SidebarWidget 
          title="Categories" 
          links={sidebarData.categories} 
        />
        <SidebarWidget 
          title="Meta" 
          links={sidebarData.meta} 
        />
      </ul>
    </aside>
  );
}